export default "__VITE_ASSET__D7cPhf1I__"